import { Box, Stack, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import { type CollectionDistrict } from '../../../models/peerToPeer/Collection'
import { completionLabel } from '../../../models/peerToPeer/collectionLabels'
import { RemindAction } from './dashboard/RemindAction'
import { styles } from './FormCompletions.styles'

interface Props {
  district: CollectionDistrict
  organizationId: number
  reportingYearId: number
  readOnly: boolean
}

export const CompletionDistrictCard = ({ district, organizationId, reportingYearId, readOnly }: Props): JSX.Element => {
  const outstanding = district.buildings.some(building => !building.isComplete)

  return (
    <Box sx={styles.card} data-testid={`p2pCompletionDistrict-${district.districtOrganizationId}`}>
      <Box sx={styles.cardHeader}>
        <Typography variant='subtitle2' sx={{ fontWeight: 700 }}>{district.name}</Typography>
      </Box>
      <Box sx={styles.cardBody}>
        {district.buildings.map(building => (
          <Stack key={building.organizationBuildingId} direction='row' alignItems='flex-start' gap='10px'>
            {building.isComplete
              ? <CheckCircleIcon sx={styles.statusIcon(true)} data-testid='p2pBuildingComplete' />
              : <RadioButtonUncheckedIcon sx={styles.statusIcon(false)} data-testid='p2pBuildingIncomplete' />}
            <Box sx={{ minWidth: 0 }}>
              <Typography variant='body1' sx={{ fontWeight: 600 }}>{building.name}</Typography>
              <Typography variant='caption' color='text.secondary'>{completionLabel(building)}</Typography>
            </Box>
          </Stack>
        ))}
        {district.buildings.length === 0 && <Typography variant='caption' color='text.secondary'>No buildings.</Typography>}
        {!readOnly && outstanding &&
          <Box sx={styles.remind}>
            <RemindAction
              organizationId={organizationId} reportingYearId={reportingYearId}
              targetDistrictOrganizationIds={[district.districtOrganizationId]}
            />
          </Box>}
      </Box>
    </Box>
  )
}
